module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item__tasks"
  }, [(!_vm.activeNorm) ? _c('Loader', {
    attrs: {
      "isSmall": true,
      "bg-color": "#fff"
    }
  }) : _c('table', {
    staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "d-table__title",
    attrs: {
      "colspan": "2"
    }
  }, [_c('h4', [_vm._v("Årsverk")])])])]), _vm._v(" "), _c('tbody', [(_vm.activeNorm.length < 1) ? _c('tr', [_c('td', {
    staticClass: "italic"
  }, [_vm._v("Ikke tildelt årsverk")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeNormFormatted), function(item) {
    return (_vm.activeNorm.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.planfestet))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Undervisning")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.user.v_user_subjects_hours_label))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oppgaver")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.user.v_user_tasks_hours_label))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.egenDisponibel))])])])])]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__tasks marg-10-bottom"
  }, [_c('thead', [_c('tr', [_vm._m(2), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.user.v_total_teaching_percentage_label) + "\n      ")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.user.v_user_subjects_hours_label) + "\n      ")])])]), _vm._v(" "), _c('tbody', [(_vm.user.v_user_subjects.length < 1) ? _c('tr', [_c('td', {
    staticClass: "italic"
  }, [_vm._v("Ingen undervisning")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.v_user_subjects), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td', [_c('div', {
      staticClass: "task-with-edit"
    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
      staticClass: "subjects_subject subjects_subject__simple",
      style: ([{
        'border-left-color': task.color
      }, {
        'background-color': task.color
      }])
    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
      staticClass: "subjects_subject subjects_subject--not-subject"
    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v("\n        " + _vm._s(task.v_calendar) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v("\n        " + _vm._s(task.v_percentage_label) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v("\n        " + _vm._s(task.v_hours_label) + "\n      ")])])
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__tasks marg-10-bottom"
  }, [_c('thead', [_c('tr', [_vm._m(3), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.user.v_user_tasks_hours_label))])])]), _vm._v(" "), _c('tbody', [(_vm.user.v_user_tasks.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen oppgaver")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.v_user_tasks), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td', [_c('div', {
      staticClass: "task-with-edit"
    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
      staticClass: "subjects_subject subjects_subject__simple",
      style: ([{
        'border-left-color': task.color
      }, {
        'background-color': task.color
      }])
    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
      staticClass: "subjects_subject subjects_subject--not-subject"
    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v("\n        " + _vm._s(task.v_hours_label) + "\n      ")])])
  })], 2)]), _vm._v(" "), _c('SubjectsDistributionUserAgreements', {
    attrs: {
      "userId": _vm.user.id,
      "userAgreements": _vm.activeUserAgreements,
      "isReadAgreements": false
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Sum planfestet arbeidstid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Sum egendisponibel resttid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "d-table__title",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "d-table__title__header"
  }, [_c('h4', [_vm._v("Undervisning")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "d-table__title"
  }, [_c('h4', [_vm._v("Oppgaver")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f33ea8f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arbeidsplan/ArbeidsplanUser.vue
// module id = 1643
// module chunks = 1